export const queryVariables = {
    withRating: true,
};
